/*
 * @Description:
 * @Date: 2021-11-08 11:07:35
 */
/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

export default {
  selection: {
    type: 'selection',
    prop: 'index',
    reserve: true,
    selectable: row => row.zbBlackStatus != 2
  },
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '姓名',
    prop: 'fullName'
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },
  taskNum: {
    label: '新增任务数量',
    prop: 'taskNum',
    showToolTip: false,
    render(h, ctx, row) {
      const parent = ctx.parent;
      const input = e => {
        const value = +e;
        if (isNaN(value) || /\./.test(value)) {
          parent.$message('请填写正整数');
          return;
        }
        if (value > 10 || value <= 0) {
          parent.$message('请填写1~10任务数量');
          return;
        }
        row.taskNum = value;
      };
      return <el-input type="number" value={row.taskNum} onInput={input} />;
    }
  }
};
